import { InputBase } from "components/Atoms/formInputs/InputBase";
import React from "react";

interface Props {
  value: string
  onChange: (newTitle: string) => void
  maxLength: number
  onBlur?: () => void
  onFocus?: () => void
  onEnter?: () => void
  onEsc?: () => void
  focusOnMount?: boolean
  disabled?: boolean
  placeholder?: string
  loading?: boolean
  hasError?: boolean;
  onPaste?: (e: React.ClipboardEvent) => void;
  width?: number;
}

const OptionalTextInput = (props: Props) => {
  return <InputBase
    placeholder={props.placeholder}
    value={props.value}
    onChange={props.onChange}
    maxLength={props.maxLength}
    onBlur={props.onBlur}
    onFocus={props.onFocus}
    onEsc={props.onEsc}
    onEnter={props.onEnter}
    onPaste={props.onPaste}
    width={props.width}
    disabled={props.disabled}
    loading={props.loading}
    error={props.hasError}
    focusOnMount={props.focusOnMount}
  />
};

export default OptionalTextInput;